import type { CSSProperties } from 'react'
import { normalizeRotationDegrees } from '@/lib/transforms/geometry'
import type { UnifiedSelectionResizeHandle } from '@/lib/transforms/types/unified-selection-resize-handle'

const HANDLE_AXIS_DEGREES: Record<UnifiedSelectionResizeHandle, number> = {
  e: 0,
  w: 0,
  nw: 45,
  se: 45,
  n: 90,
  s: 90,
  ne: 135,
  sw: 135,
}

const RESIZE_CURSOR_AXES: Array<{ axis: number; cursor: CSSProperties['cursor'] }> = [
  { axis: 0, cursor: 'ew-resize' },
  { axis: 45, cursor: 'nwse-resize' },
  { axis: 90, cursor: 'ns-resize' },
  { axis: 135, cursor: 'nesw-resize' },
]

function normalizeAxisDegrees(d: number): number {
  const wrapped = normalizeRotationDegrees(d)

  return wrapped >= 180 ? wrapped - 180 : wrapped
}

function axisDistanceDegrees(a: number, b: number): number {
  const diff = Math.abs(a - b)

  return Math.min(diff, 180 - diff)
}

export function getResizeCursorForHandle(
  direction: UnifiedSelectionResizeHandle,
  rotationDeg = 0
): string {
  const base = HANDLE_AXIS_DEGREES[direction]
  const rotatedAxis = normalizeAxisDegrees(base + rotationDeg)
  const nearest = RESIZE_CURSOR_AXES.reduce((best, candidate) => {
    const bestDistance = axisDistanceDegrees(rotatedAxis, best.axis)
    const candidateDistance = axisDistanceDegrees(rotatedAxis, candidate.axis)

    return candidateDistance < bestDistance ? candidate : best
  }, RESIZE_CURSOR_AXES[0])

  return nearest.cursor ?? 'default'
}
